/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatMessagesContainer.vue?vue&type=template&id=73b32796"
import script from "./ChatMessagesContainer.vue?vue&type=script&lang=js"
export * from "./ChatMessagesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b32796')) {
      api.createRecord('73b32796', component.options)
    } else {
      api.reload('73b32796', component.options)
    }
    module.hot.accept("./ChatMessagesContainer.vue?vue&type=template&id=73b32796", function () {
      api.rerender('73b32796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatMessagesContainer.vue"
export default component.exports